// extracted by mini-css-extract-plugin
export default {"description":"verificationScreen_description__v+Hyy","separator":"verificationScreen_separator__XjUCc"};